import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  CompanyCreate,
  CompanySearchInterface,
  CompanyUpdateInterface,
  ICompanyJoinResponse,
  ICreateCompanyResponse,
  IEmailDomainValidationPayload,
  IEmailDomainValidationResponse,
  ISendVerificationCompanyMailResponse, IUpdateCompanyResponse,
  IValidateCompanyEmailsResponse,
  SendJoinRequest,
  SendVerificationCompanyMail
} from "../interfaces/ICompany";

const BASE_API = process.env.REACT_APP_BASE_API;
const KRANKQUE_SECRET_KEY = process.env.REACT_APP_KRANKQUE_SECRET_KEY;
const KRANKQUE_APPLICATION_ID = process.env.REACT_APP_KRANKQUE_APPLICATION_ID;

export const companySlice = createApi({
  reducerPath: 'company',
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_API,
    prepareHeaders: (headers, { getState }) => {
      headers.set('Content-Type', 'application/json');

      if (KRANKQUE_SECRET_KEY) {
        headers.set('krankque-secret-key', KRANKQUE_SECRET_KEY);
      }

      if (KRANKQUE_APPLICATION_ID) {
        headers.set('krankque-application-id', KRANKQUE_APPLICATION_ID);
      }

      return headers;
    }
  }),
  endpoints: (builder) => ({
    searchCompany: builder.mutation<IValidateCompanyEmailsResponse, CompanySearchInterface>({
      query: (body) => ({
        url: '/validate-company-emails',
        method: 'POST',
        body
      })
    }),
    updateCompany: builder.mutation<IUpdateCompanyResponse, CompanyUpdateInterface>({
      query: (req) => ({
        url: `/company?id=${req.id}`,
        method: 'PUT',
        body: req.body,
        headers: {
          Authorization: `Bearer: ${req.accessToken}`
        }
      })
    }),
    validateCompanyByDomain: builder.mutation<IEmailDomainValidationResponse, IEmailDomainValidationPayload>({
      query: (body) => ({
        url: `/email-validate`,
        method: 'POST',
        body
      })
    }),
    sendVerificationCompanyMail: builder.mutation<ISendVerificationCompanyMailResponse, SendVerificationCompanyMail>({
      query: (body) => ({
        url: '/verify-company',
        method: 'POST',
        body
      })
    }),
    createCompany: builder.mutation<ICreateCompanyResponse, CompanyCreate>({
      query: (req) => ({
        url: `/company`,
        method: 'POST',
        body: req.body,
        headers: {
          Authorization: `Bearer ${req.accessToken}`
        }
      })
    }),
    sendJoinRequest: builder.mutation<ICompanyJoinResponse, SendJoinRequest>({
      query: (req) => ({
        url: `company/join`,
        method: 'POST',
        body: req.body,
        headers: {
          Authorization: `Bearer ${req.accessToken}`
        }
      })
    }),
  })
});

export const {
  useSearchCompanyMutation,
  useSendVerificationCompanyMailMutation,
  useCreateCompanyMutation,
  useSendJoinRequestMutation,
  useUpdateCompanyMutation,
  useValidateCompanyByDomainMutation,
} = companySlice;
